import { Calendar, MessageSquare } from 'lucide-react'
import styles from '@styles/AdminPanel.module.css'
import PropTypes from 'prop-types'

const Notifications = ({ notifications }) => {
  return (
    <div className={styles.notificationsContainer}>
      {notifications.slice(-5).map((notification) => (
        <div key={notification.id} className={`${styles.notification} ${styles[notification.type]}`}>
          {notification.type === 'citas' ? <Calendar size={16} /> : <MessageSquare size={16} />}
          <p>{notification.message}</p>
        </div>
      ))}
    </div>
  )
}

Notifications.propTypes = {
  notifications: PropTypes.array.isRequired,
}

export default Notifications
